/* eslint-disable */ import { assertNumber, attributeSelectionComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const topCircleComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('TopCircle').attach(memoEval((self)=>[
            self.$objectName
        ], ($objectName)=>({
            fileUrl: '/models/algu3d.glb',
            objectName: $objectName,
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('TopCircle').attach(memoEval((self)=>[
            self.diameter,
            self.thickness,
            self.$edgeFinishFacet,
            self.$edgeFinishRound
        ], (diameter, thickness, $edgeFinishFacet, $edgeFinishRound)=>({
            morphTargetInfluences: {
                Length: {
                    value: diameter,
                    scaleOne: 3000,
                    scaleZero: 1600
                },
                Width: {
                    value: diameter,
                    scaleOne: 1300,
                    scaleZero: 900
                },
                Depth: {
                    value: thickness,
                    scaleOne: 60,
                    scaleZero: 12
                },
                Facet: {
                    value: $edgeFinishFacet,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Bol: {
                    value: $edgeFinishRound,
                    scaleOne: 1,
                    scaleZero: 0
                }
            }
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'diameter', true).withEntity('TopCircle').attach(memoEval((self)=>[
            self.diameter,
            self.$diameterOptions
        ], (diameter, $diameterOptions)=>({
            value: diameter,
            options: $diameterOptions
        })), (state)=>{
        assertNumber(state.value);
        return {
            diameter: state.value
        };
    })
];

//# sourceMappingURL=top-circle.js.map